"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1453],{

/***/ 51453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gR": function() { return /* binding */ IsInListIndicator; },
/* harmony export */   "M8": function() { return /* binding */ CompanyListRowSection; },
/* harmony export */   "gW": function() { return /* binding */ CompanyListRow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87379);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40929);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(23855);
/* harmony import */ var mdi_react_StoreIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27131);
/* harmony import */ var mdi_react_StoreIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mdi_react_StoreIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mdi_react_DotsHorizontalIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56276);
/* harmony import */ var mdi_react_DotsHorizontalIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mdi_react_DotsHorizontalIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26482);
/* harmony import */ var mdi_react_AccountMultipleIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16450);
/* harmony import */ var mdi_react_AccountMultipleIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(mdi_react_AccountMultipleIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var mdi_react_TrendingUpIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34989);
/* harmony import */ var mdi_react_TrendingUpIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(mdi_react_TrendingUpIcon__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _CompanyListStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31999);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22318);
/* harmony import */ var _components_Theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74815);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(17812);
/* harmony import */ var _CompanyListRowSkeleton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23834);
/* harmony import */ var _company_useCompanyActions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95804);
/* harmony import */ var _context_useUser__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95460);
/* harmony import */ var _common_constleUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(45521);
/* harmony import */ var _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47546);
/* harmony import */ var _hooks_useBreakPoint__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41894);
/* harmony import */ var _icons_VastuuGroupIcons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14432);
/* harmony import */ var _common_Constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(72916);























function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin: -26px -26px 0 0;\n  width: 8px;\n  height: 8px;\n  border-radius: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  ",
        " {\n    display: block;\n    flex: 0;\n    width: auto;\n    margin-right: 1rem;\n\n    .MuiTypography-root {\n      justify-content: flex-start;\n      text-align: left;\n      white-space: nowrap;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var IsInListIndicator = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4872dbd3-0"
})(_templateObject(), _components_Theme__WEBPACK_IMPORTED_MODULE_10__/* .Color.primary */ .Il.primary);
var SubsectionList = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4872dbd3-1"
})(_templateObject1(), _CompanyListStyle__WEBPACK_IMPORTED_MODULE_9__/* .Section */ .$0);
var CompanyListRowSection = function(param) {
    var name = param.name, title = param.title, subtitle = param.subtitle, icon = param.icon, endIcon = param.endIcon, width = param.width, right = param.right, bold = param.bold, style = param.style, subsections = param.subsections, onClick = param.onClick;
    var extraData = null;
    if (subsections) {
        extraData = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubsectionList, {
            children: subsections.map(function(props, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyListRowSection, _objectSpread({}, props, {
                    right: false,
                    width: null
                }), index);
            })
        });
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_9__/* .Section */ .$0, {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
            right: right
        }, name),
        flex: !width,
        width: width !== null && width !== void 0 ? width : null,
        right: !!right,
        bold: bold,
        pointer: !!onClick,
        style: _objectSpread({}, style),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                children: [
                    icon !== null && icon !== void 0 ? icon : null,
                    title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: title
                    }) : null,
                    endIcon !== null && endIcon !== void 0 ? endIcon : null
                ]
            }),
            !!subtitle && !extraData && subtitle,
            extraData
        ]
    }));
};
// NOTE! This is used both for search page rows and for frontpage "Viimeksi päivitetyt" also
var CompanyListRow = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var id = param.id, company1 = param.company, small = param.small, selected = param.selected, _sections = param.sections, sections = _sections === void 0 ? _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__/* .companyListRowSections */ .o4 : _sections, _element = param.element, element = _element === void 0 ? null : _element, demo = param.demo, _renderActions = param.renderActions, renderActions = _renderActions === void 0 ? null : _renderActions, tmp = param.actionsComponent, ActionsComponent = tmp === void 0 ? null : tmp, style = param.style, onMenu = param.onMenu, onClick = param.onClick;
    var isLoggedIn = (0,_context_useUser__WEBPACK_IMPORTED_MODULE_13__/* .useUser */ .a)().isLoggedIn;
    var ref2 = (0,_company_useCompanyActions__WEBPACK_IMPORTED_MODULE_12__/* .useCompanyActionsInSearch */ .s)(company1 === null || company1 === void 0 ? void 0 : company1.companyID), isLiked = ref2.isLiked, isDisliked = ref2.isDisliked, isInCustomList = ref2.isInCustomList, listIDs = ref2.listIDs, renderComboButton = ref2.renderComboButton;
    var isSmall = (0,_hooks_useBreakPoint__WEBPACK_IMPORTED_MODULE_15__/* .useBreakPoint */ .P)('small');
    if (company1 === null) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CompanyListRowSkeleton__WEBPACK_IMPORTED_MODULE_11__/* .CompanyListRowSkeleton */ .F, {
            small: small
        }));
    }
    var handleMenuClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (onMenu) onMenu(company1.companyID, event);
    }, [
        company1.companyID,
        onMenu
    ]);
    var renderListRowActions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (renderActions) {
            return renderActions(_objectSpread({}, company1, {
                isLiked: isLiked,
                isDisliked: isDisliked,
                listIDs: listIDs
            }));
        }
        var width = isSmall ? 48 : _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__/* .sectionWidths.actions */ .sq.actions;
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_9__/* .Actions */ .eX, {
            style: {
                width: width
            },
            className: "actions",
            children: [
                !isSmall && renderComboButton(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                    "aria-label": "more options",
                    component: "span",
                    disabled: !isLoggedIn,
                    onClick: handleMenuClick,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_DotsHorizontalIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                        isInCustomList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IsInListIndicator, {})
                    ]
                })
            ]
        }));
    }, [
        id,
        isLiked,
        isDisliked,
        isInCustomList,
        isLoggedIn,
        isSmall
    ]);
    var renderListRowSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(section, index) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyListRowSection, _objectSpread({}, section), index);
    }, []);
    var renderListRow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(company) {
        var ref, ref1;
        var hasLogo = company.logo && company.logo.path;
        // if established in previous year or later, show month
        var previousYear = new Date().getFullYear() - 1;
        var establishedMonthOrEmpty = company.dateEstablished && new Date(company.dateEstablished).getFullYear() >= previousYear ? (0,date_fns__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(company.dateEstablished), 'M') + '/' : '';
        var dateEstablishedString = company.dateEstablished ? establishedMonthOrEmpty + (0,date_fns__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(company.dateEstablished), 'yyyy') : '';
        var numberOfEmployeesString = (0,_common_constleUtils__WEBPACK_IMPORTED_MODULE_23__/* .formatMinMax */ .m8)(company.numberOfEmployees);
        var turnoverString = (0,_common_constleUtils__WEBPACK_IMPORTED_MODULE_23__/* .formatMinMax */ .m8)(company.turnover, '€');
        var hasNumberOfEmployees = !!numberOfEmployeesString;
        var hasTurnover = !!turnoverString;
        var logoStyleProp = {};
        if (hasLogo) {
            logoStyleProp = {
                backgroundImage: "url(/api/v1/files/public/42x42M-".concat(company.logo.path, ")"),
                backgroundColor: 'white',
                border: 'none'
            };
        }
        var companyFlagIcons = (sections.includes('flags') && company.flags || []).filter(function(f) {
            return f.flagID != _common_Constants__WEBPACK_IMPORTED_MODULE_17__/* .CompanyFlag.IS_VASTUUGROUP */ .Qi.IS_VASTUUGROUP;
        }).map(function(f, i) {
            return f.value && f.flagID && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_VastuuGroupIcons__WEBPACK_IMPORTED_MODULE_16__/* .VastuuGroupIcon */ .R, {
                style: {
                    verticalAlign: '13%'
                },
                companyFlagID: f.flagID
            }, i);
        });
        var businessIDSection = {
            name: 'businessID',
            subtitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        variant: "body2",
                        component: "span",
                        style: {
                            display: 'inline'
                        },
                        children: company.businessID
                    }),
                    companyFlagIcons
                ]
            })
        };
        var locationSection = {
            name: 'domicile',
            title: (ref = company.domicile) === null || ref === void 0 ? void 0 : ref.cityName,
            subtitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                variant: "body2",
                children: (ref1 = company.domicile) === null || ref1 === void 0 ? void 0 : ref1.provinceName
            }),
            width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__/* .sectionWidths.location */ .sq.location
        };
        var dateEstablished = {
            name: 'dateEstablished',
            title: dateEstablishedString,
            width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__/* .sectionWidths.year */ .sq.year,
            right: true
        };
        var employeesSection = {
            name: 'numberOfEmployees',
            title: numberOfEmployeesString,
            endIcon: hasNumberOfEmployees && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_AccountMultipleIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                size: 16
            }),
            width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__/* .sectionWidths.employees */ .sq.employees,
            right: true
        };
        var turnoverSection = {
            name: 'turnover',
            title: hasTurnover ? (0,_common_constleUtils__WEBPACK_IMPORTED_MODULE_23__/* .formatMinMax */ .m8)(company.turnover) + '€' : '',
            // subtitle: '2019',
            icon: hasTurnover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_TrendingUpIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
                size: 16
            }),
            width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_14__/* .sectionWidths.turnover */ .sq.turnover,
            right: true
        };
        var nameSubsections = [];
        if (!demo) {
            if (!sections.includes('turnover')) {
                nameSubsections.push(turnoverSection);
            }
            if (nameSubsections.length) {
                nameSubsections.unshift(businessIDSection);
            }
        }
        // Enforce that all companyListRowSections exept for "actions" is defined here
        var sectionProps = {
            name: {
                name: 'name',
                title: company.name,
                subtitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            variant: "body2",
                            component: "span",
                            style: {
                                display: 'inline'
                            },
                            children: company.businessID
                        }),
                        companyFlagIcons
                    ]
                }),
                subsections: nameSubsections.length ? nameSubsections : undefined
            },
            location: locationSection,
            year: dateEstablished,
            employees: employeesSection,
            turnover: turnoverSection
        };
        // Pick visible sections based on the "sections" prop
        var visibleSections = sections.filter(function(section) {
            return section !== 'actions' && section !== 'flags';
        }).map(function(section) {
            return sectionProps[section];
        });
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_9__/* .Logo */ .TR, {
                    style: logoStyleProp,
                    children: !hasLogo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_StoreIcon__WEBPACK_IMPORTED_MODULE_4___default()), {})
                }),
                visibleSections.map(renderListRowSection),
                !ActionsComponent && sections.includes('actions') && renderListRowActions(),
                ActionsComponent && sections.includes('actions') && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionsComponent, _objectSpread({}, company))
            ]
        }));
    }, [
        id,
        small,
        isLiked,
        isDisliked,
        isInCustomList,
        sections,
        isLoggedIn,
        isSmall
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X2, {
        id: id,
        as: element,
        style: style,
        role: "option",
        "aria-selected": selected || false,
        small: small,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
            href: {
                pathname: '/company/[hash]/[slug]',
                query: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__/* .companyUrlParts */ .EH)(company1.url)
            },
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                children: renderListRow(company1)
            })
        })
    }));
}, /**
   * Prevents unnecessary updates on company row component.
   * This has a huge performance boost on the search page.
   * @returns Is component equal to last props
   */ function(a, b) {
    var ref, ref3;
    if (((ref = a.company) === null || ref === void 0 ? void 0 : ref.companyID) !== ((ref3 = b.company) === null || ref3 === void 0 ? void 0 : ref3.companyID)) return false;
    if (a.small !== b.small) return false;
    if (a.selected !== b.selected) return false;
    if (a.sections !== b.sections) return false;
    return true;
});


/***/ }),

/***/ 47546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o4": function() { return /* binding */ companyListRowSections; },
/* harmony export */   "sq": function() { return /* binding */ sectionWidths; },
/* harmony export */   "Zd": function() { return /* binding */ useSearchSections; }
/* harmony export */ });
/* unused harmony exports hideSectionsInTablet, hideSectionsInMobile */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useBreakPoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41894);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var companyListRowSections = [
    'name',
    'location',
    'year',
    'employees',
    'turnover',
    'actions',
    'flags'
];
var hideSectionsInTablet = [
    'employees',
    'turnover'
];
var hideSectionsInMobile = [
    'location',
    'year',
    'employees',
    'turnover'
];
var sectionWidths = {
    name: null,
    location: '20%',
    year: 80,
    employees: 160,
    turnover: 160,
    actions: 104 + 24 + 8,
    flags: null
};
/** Helper to make getting search sections easy */ var useSearchSections = function() {
    var _hiddenSections, _hiddenSections1;
    var isMedium = (0,_hooks_useBreakPoint__WEBPACK_IMPORTED_MODULE_1__/* .useBreakPoint */ .P)('medium');
    var isSmall = (0,_hooks_useBreakPoint__WEBPACK_IMPORTED_MODULE_1__/* .useBreakPoint */ .P)('small');
    var hiddenSections = [];
    if (isMedium) (_hiddenSections = hiddenSections).push.apply(_hiddenSections, _toConsumableArray(hideSectionsInTablet));
    if (isSmall) (_hiddenSections1 = hiddenSections).push.apply(_hiddenSections1, _toConsumableArray(hideSectionsInMobile));
    var sections = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return companyListRowSections.filter(function(section) {
            return !hiddenSections.includes(section);
        });
    }, [
        isMedium,
        isSmall
    ]);
    return sections;
};


/***/ }),

/***/ 23834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CompanyListRowSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58365);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87452);
/* harmony import */ var mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CompanyListStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31999);
/* harmony import */ var _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47546);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74815);








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CompanyListRowSkeletonSection = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var subtitle = param.subtitle, width = param.width, right = param.right, premium = param.premium;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$0, {
        flex: !width,
        width: width !== null && width !== void 0 ? width : null,
        right: !!right,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    animation: premium ? false : 'wave',
                    width: "80%"
                })
            }),
            subtitle !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "body2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    animation: premium ? false : 'wave',
                    width: "30%"
                })
            })
        ]
    });
});
var CompanyListRowSkeleton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param1) {
    var _sections = param1.sections, sections1 = _sections === void 0 ? null : _sections, small = param1.small, premium = param1.premium;
    var searchSections = (0,_CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__/* .useSearchSections */ .Zd)();
    var visibleSection = sections1 !== null && sections1 !== void 0 ? sections1 : searchSections;
    var renderListRowActions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_3__/* .Actions */ .eX, {
            style: {
                width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__/* .sectionWidths.actions */ .sq.actions
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "icon",
                animation: premium ? false : 'wave',
                width: 24,
                height: 24,
                style: {
                    transform: 'none',
                    borderRadius: '50%',
                    margin: 0,
                    marginRight: '1rem'
                }
            })
        });
    }, [
        premium
    ]);
    var renderListRowSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(section, index) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyListRowSkeletonSection, _objectSpread({}, section, {
            premium: premium
        }), index);
    }, [
        premium
    ]);
    var renderListRow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var sections = [
            // Name
            {
                name: 'name',
                title: '',
                subtitle: ''
            },
            // Location
            {
                name: 'location',
                title: '',
                subtitle: '',
                width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__/* .sectionWidths.location */ .sq.location
            },
            // Year
            {
                name: 'year',
                title: '',
                width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__/* .sectionWidths.year */ .sq.year,
                right: true
            },
            // Employees
            {
                name: 'employees',
                title: '',
                width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__/* .sectionWidths.employees */ .sq.employees,
                right: true
            },
            // Turnover
            {
                name: 'turnover',
                title: '',
                subtitle: '',
                width: _CompanyListRowSections__WEBPACK_IMPORTED_MODULE_4__/* .sectionWidths.turnover */ .sq.turnover,
                right: true
            }, 
        ].filter(function(param) {
            var name = param.name;
            return visibleSection.includes(name);
        });
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_3__/* .Logo */ .TR, {
                    children: premium ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
                        color: _Theme__WEBPACK_IMPORTED_MODULE_5__/* .Color.primary */ .Il.primary,
                        size: 16
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "icon",
                        animation: "wave",
                        width: 42,
                        height: 42,
                        style: {
                            transform: 'none',
                            borderRadius: 4,
                            margin: 0
                        }
                    })
                }),
                sections.map(renderListRowSection),
                visibleSection.includes('actions') && renderListRowActions()
            ]
        }));
    }, [
        small,
        premium,
        visibleSection
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CompanyListStyle__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
        small: small,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: renderListRow()
        })
    }));
});


/***/ }),

/***/ 31999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "eX": function() { return /* binding */ Actions; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "TR": function() { return /* binding */ Logo; }
/* harmony export */ });
/* unused harmony export Button */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83852);
/* harmony import */ var _components_Theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74815);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      flex: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      width: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: pointer;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  text-align: ",
        ";\n  user-select: none;\n\n  .MuiTypography-root {\n    display: flex;\n    justify-content: ",
        ";\n    align-items: center;\n    font-weight: ",
        ";\n  }\n\n  .MuiTypography-body1 {\n    > svg,\n    .premium-icon {\n      &:first-child {\n        margin-right: 0.3rem;\n      }\n\n      &:last-child {\n        margin-left: 0.3rem;\n      }\n    }\n  }\n\n  .MuiTypography-body2 {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 0 0.5rem 0 0;\n\n  > span {\n    margin-right: 0.25rem;\n    opacity: 0;\n    color: ",
        ";\n  }\n\n  > span:first-child {\n    opacity: 0;\n  }\n\n  > span:last-child {\n    opacity: 0.5;\n  }\n\n  .MuiButtonBase-root {\n    &:active,\n    &:focus,\n    &.active {\n      opacity: 1;\n    }\n\n    &.liked {\n      color: ",
        ";\n    }\n\n    &.disliked {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        > *:first-child {\n          margin: 0.2rem 1rem;\n        }\n\n        &:hover {\n          box-shadow: none;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: ",
        "px;\n  background-color: ",
        ";\n\n  &:not(:first-child) a {\n    margin-top: -2px;\n  }\n\n  &:first-child {\n    border-radius: ",
        "px ",
        "px 0 0;\n\n    &:after {\n      border-radius: ",
        "px ",
        "px 0 0;\n    }\n  }\n\n  &:last-child {\n    border-radius: 0 0 ",
        "px ",
        "px;\n\n    &:after {\n      border-radius: 0 0 ",
        "px ",
        "px;\n    }\n\n    a {\n      border-bottom: none;\n\n      &:after {\n        height: 100%;\n      }\n    }\n  }\n\n  &:first-child:last-child {\n    border-radius: ",
        "px;\n  }\n\n  &[aria-selected='true'] a {\n    background-color: ",
        ";\n\n    &:after {\n      border: 2px solid ",
        ";\n    }\n  }\n\n  > a {\n    display: flex;\n    flex: 1;\n    position: relative;\n    align-items: center;\n    border-radius: inherit;\n    border-bottom: 2px solid ",
        ";\n    outline: none;\n    z-index: 1;\n\n    box-sizing: border-box;\n\n    transition: box-shadow 100ms ease;\n\n    &:after {\n      content: '';\n      display: block;\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: calc(100% + 2px);\n      border: 2px solid transparent;\n      border-radius: inherit;\n      pointer-events: none;\n\n      box-sizing: border-box;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n      box-shadow: 0 0 11px rgba(149, 157, 165, 0.15);\n      z-index: 2;\n\n      &:after {\n        border: 2px solid ",
        ";\n      }\n\n      > button {\n        opacity: 1;\n      }\n\n      ",
        " {\n        > span {\n          opacity: 1;\n        }\n      }\n    }\n\n    &:active,\n    &:focus {\n      background-color: ",
        ";\n\n      &:after {\n        border: 2px solid ",
        ";\n      }\n\n      > button {\n        opacity: 1;\n      }\n\n      ",
        " {\n        > span {\n          opacity: 1;\n        }\n      }\n    }\n\n    ",
        "\n    small {\n      display: block;\n      margin-top: 0.2rem;\n      font-size: 0.8rem;\n      color: ",
        ";\n    }\n\n    p {\n      > svg {\n        // margin-bottom: -2px;\n        color: ",
        ";\n      }\n    }\n\n    p:first-of-type {\n      flex: 1;\n    }\n\n    p:nth-of-type(2) {\n      flex: 0.5;\n      min-width: 60px;\n    }\n\n    p:nth-of-type(3) {\n      width: 100px;\n    }\n\n    p:nth-of-type(4) {\n      text-align: right;\n      width: 150px;\n    }\n\n    hr {\n      margin: 0 1rem;\n      height: 42px;\n      width: 2px;\n      border: none;\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 1.5rem 0.75rem;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 1.5rem 1.5rem;\n  width: 42px;\n  height: 42px;\n  background-color: ",
        ";\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border-radius: ",
        "px;\n  overflow: hidden;\n\n  > figure.logo {\n    width: 100%;\n    height: 100%;\n  }\n\n  svg {\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  align-self: stretch;\n  width: 46px;\n  background: none;\n  border: 2px solid transparent;\n  outline: none;\n  opacity: 0;\n  color: ",
        ";\n\n  &.star.selected {\n    opacity: 1;\n    color: ",
        ";\n  }\n\n  &.thumbUp.selected {\n    opacity: 1;\n    color: ",
        ";\n  }\n\n  &.thumbDown.selected {\n    opacity: 1;\n    color: ",
        ";\n  }\n\n  &:active,\n  &:focus {\n    border-color: ",
        ";\n    background-color: ",
        ";\n\n    opacity: 1;\n  }\n\n  &:hover {\n    border-color: transparent;\n    background-color: ",
        ";\n\n    &.star {\n      color: ",
        ";\n    }\n  }\n\n  &:first-of-type {\n    margin-left: 1rem;\n  }\n\n  &:not(:last-of-type) {\n    margin-right: -2px;\n  }\n\n  @media (max-width: 1000px) {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var Section = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70f780ef-0"
})(_templateObject3(), function(param) {
    var flex = param.flex;
    return flex && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
}, function(param) {
    var width = param.width;
    return width !== null && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), typeof width === 'number' ? "".concat(width, "px") : width);
}, function(param) {
    var pointer = param.pointer;
    return !!pointer && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
}, function(param) {
    var right = param.right;
    return right ? 'right' : 'left';
}, function(param) {
    var right = param.right;
    return right ? 'flex-end' : 'flex-start';
}, function(param) {
    var bold = param.bold;
    return bold ? '500' : 'normal';
});
var Actions = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70f780ef-1"
})(_templateObject4(), _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.black */ .Il.black, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.green */ .Il.green, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.red */ .Il.red);
var Row = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70f780ef-2"
})(_templateObject6(), _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .companyRowHeight */ .Hm, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.white */ .Il.white, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.select */ .Il.select, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.primary */ .Il.primary, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.background */ .Il.background, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.hover */ .Il.hover, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.secondary */ .Il.secondary, Actions, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.select */ .Il.select, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.primary */ .Il.primary, Actions, function(props) {
    return props.small && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5());
}, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.disabled */ .Il.disabled, (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(0.5, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.black */ .Il.black), _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.background */ .Il.background);
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-70f780ef-3"
})(_templateObject8(), _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.background */ .Il.background, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.disabled */ .Il.disabled, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject7())));
var Button = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-70f780ef-4"
})(_templateObject9(), _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.black */ .Il.black, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.primary */ .Il.primary, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.green */ .Il.green, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.red */ .Il.red, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.primary */ .Il.primary, (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .darken */ ._j)(0.05, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.select */ .Il.select), (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .darken */ ._j)(0.075, _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.hover */ .Il.hover), _components_Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.primary */ .Il.primary);


/***/ }),

/***/ 95804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useCompanyActionsInSearch; },
/* harmony export */   "u": function() { return /* binding */ useCompanyActionsInPage; }
/* harmony export */ });
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14894);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14316);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(40242);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86896);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17812);
/* harmony import */ var mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64021);
/* harmony import */ var mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50450);
/* harmony import */ var mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mdi_react_ThumbsUpOutlineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70698);
/* harmony import */ var mdi_react_ThumbsUpOutlineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mdi_react_ThumbsUpOutlineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var mdi_react_AlertDecagramOutlineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82446);
/* harmony import */ var mdi_react_AlertDecagramOutlineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(mdi_react_AlertDecagramOutlineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _common_Constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72916);
/* harmony import */ var _context_useUser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95460);
/* harmony import */ var _context_listsStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39550);
/* harmony import */ var _context_searchStore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90672);
/* harmony import */ var _lib_state__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54442);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74815);


















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * Zustand store to handle single company action cache.
 * This will allow instant updates for likes, dislikes & lists.
 */ var useCompanyActionCacheState = (0,zustand__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_14__/* .combine */ .$e)({}, function(set) {
    return {
        set: set
    };
}));
/**
 * Central place for everything to do with company actions
 * These include:
 * - Liking
 * - Disliking
 * - Interaction with lists
 */ var useCompanyActions = function(companyID, actionData, doEdit) {
    var ref, ref1;
    var formatMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)().formatMessage;
    var isLoggedIn = (0,_context_useUser__WEBPACK_IMPORTED_MODULE_8__/* .useUser */ .a)().isLoggedIn;
    var ref2 = (0,_lib_state__WEBPACK_IMPORTED_MODULE_11__/* .useScopedState */ .S)(_context_listsStore__WEBPACK_IMPORTED_MODULE_9__/* .listsState */ .jy, [
        'lists'
    ]), lists = ref2.lists, doAddItem = ref2.doAddItem, doRemoveItem = ref2.doRemoveItem;
    var isLoadingRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var likedListID = ((ref = lists.find(function(list) {
        return list.listTypeID === _common_Constants__WEBPACK_IMPORTED_MODULE_7__/* .ListType.LIKED */ .RH.LIKED;
    })) === null || ref === void 0 ? void 0 : ref.listID) || null;
    var dislikedListID = ((ref1 = lists.find(function(list) {
        return list.listTypeID === _common_Constants__WEBPACK_IMPORTED_MODULE_7__/* .ListType.DISLIKED */ .RH.DISLIKED;
    })) === null || ref1 === void 0 ? void 0 : ref1.listID) || null;
    var isLiked = actionData.isLiked, isDisliked = actionData.isDisliked, listIDs = actionData.listIDs;
    var likeText = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return formatMessage({
            id: 'company.actions.like',
            defaultMessage: 'Lis\xe4\xe4 tykk\xe4yksiin'
        });
    }, []);
    var removeLikeText = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return formatMessage({
            id: 'company.actions.remove-like',
            defaultMessage: 'Poista tyk\xe4tyist\xe4'
        });
    }, []);
    var dislikeText = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return formatMessage({
            id: 'company.actions.dislike',
            defaultMessage: 'Lis\xe4\xe4 v\xe4ltettyihin'
        });
    }, []);
    var removeDislikeText = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return formatMessage({
            id: 'company.actions.remove-dislike',
            defaultMessage: 'Poista v\xe4ltetyist\xe4'
        });
    }, []);
    /** Helper to allow other components to easily access translations */ var dictionary = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            likeText: likeText,
            removeLikeText: removeLikeText,
            dislikeText: dislikeText,
            removeDislikeText: removeDislikeText
        };
    }, []);
    /** Helper to check if company is in user or company lists */ var isInCustomList = (listIDs || []).length > 0;
    /** Helper to return a given status, and set loading state to false */ var resolve = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(status) {
        isLoadingRef.current = false;
        return status;
    }, []);
    var handleThumbUpClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var event, status, status1, _args = arguments;
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    event = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                    if (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    if (!isLoadingRef.current) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", 'ok');
                case 4:
                    isLoadingRef.current = true;
                    if (isLiked) {
                        _ctx.next = 14;
                        break;
                    }
                    doEdit({
                        isLiked: true
                    });
                    _ctx.next = 9;
                    return doAddItem({
                        listID: likedListID,
                        companyID: companyID
                    });
                case 9:
                    status = _ctx.sent.status;
                    if (status !== 'ok') {
                        doEdit({
                            isLiked: false
                        });
                        console.error("Failed to like company (".concat(companyID, ") with status \"").concat(status, "\""));
                    } else {
                        doEdit({
                            isDisliked: false
                        });
                    }
                    return _ctx.abrupt("return", resolve(status));
                case 14:
                    doEdit({
                        isLiked: false
                    });
                    _ctx.next = 17;
                    return doRemoveItem({
                        listID: likedListID,
                        companyID: companyID,
                        pendingOverride: true
                    });
                case 17:
                    status1 = _ctx.sent.status;
                    if (status1 !== 'ok') {
                        doEdit({
                            isLiked: true
                        });
                        console.error("Failed to remove like from company (".concat(companyID, ") with status \"").concat(status1, "\""));
                    }
                    return _ctx.abrupt("return", resolve(status1));
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        companyID,
        likedListID,
        isLiked,
        doEdit
    ]);
    var handleThumbDownClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var event, status, status2, _args = arguments;
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    event = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                    if (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    if (!isLoadingRef.current) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", 'ok');
                case 4:
                    isLoadingRef.current = true;
                    if (isDisliked) {
                        _ctx.next = 14;
                        break;
                    }
                    doEdit({
                        isDisliked: true
                    });
                    _ctx.next = 9;
                    return doAddItem({
                        listID: dislikedListID,
                        companyID: companyID
                    });
                case 9:
                    status = _ctx.sent.status;
                    if (status !== 'ok') {
                        doEdit({
                            isDisliked: false
                        });
                        console.error("Failed to dislike company (".concat(companyID, ") with status \"").concat(status, "\""));
                    } else {
                        doEdit({
                            isLiked: false
                        });
                    }
                    return _ctx.abrupt("return", resolve(status));
                case 14:
                    doEdit({
                        isDisliked: false
                    });
                    _ctx.next = 17;
                    return doRemoveItem({
                        listID: dislikedListID,
                        companyID: companyID,
                        pendingOverride: true
                    });
                case 17:
                    status2 = _ctx.sent.status;
                    if (status2 !== 'ok') {
                        doEdit({
                            isDisliked: true
                        });
                        console.error("Failed to remove dislike from company (".concat(companyID, ") with status \"").concat(status2, "\""));
                    }
                    return _ctx.abrupt("return", resolve(status2));
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        companyID,
        dislikedListID,
        isDisliked,
        doEdit
    ]);
    /**
   * Removes a company from list if it exists, or adds it if it does not
   */ var handleToggleListClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(listID) {
            var event, isInList, status, status3, _args = arguments;
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null;
                        if (event) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        if (!isLoadingRef.current) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", 'ok');
                    case 4:
                        isLoadingRef.current = true;
                        isInList = listIDs.includes(listID);
                        if (isInList) {
                            _ctx.next = 15;
                            break;
                        }
                        doEdit({
                            listIDs: _toConsumableArray(listIDs).concat([
                                listID
                            ])
                        });
                        _ctx.next = 10;
                        return doAddItem({
                            listID: listID,
                            companyID: companyID
                        });
                    case 10:
                        status = _ctx.sent.status;
                        if (status !== 'ok') {
                            doEdit({
                                listIDs: listIDs
                            });
                            console.error("Failed to add company (".concat(companyID, ") to list (").concat(listID, ") with status \"").concat(status, "\""));
                        }
                        return _ctx.abrupt("return", resolve(status));
                    case 15:
                        doEdit({
                            listIDs: listIDs.filter(function(id) {
                                return id !== listID;
                            })
                        });
                        _ctx.next = 18;
                        return doRemoveItem({
                            listID: listID,
                            companyID: companyID,
                            pendingOverride: true
                        });
                    case 18:
                        status3 = _ctx.sent.status;
                        if (status3 !== 'ok') {
                            doEdit({
                                listIDs: listIDs
                            });
                            console.error("Failed to remove company (".concat(companyID, ") from list (").concat(listID, ") with status \"").concat(status3, "\""));
                        }
                        return _ctx.abrupt("return", resolve(status3));
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(listID) {
            return _ref.apply(this, arguments);
        };
    }(), [
        companyID,
        listIDs,
        doEdit
    ]);
    var renderThumbUpButton = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            "aria-label": isLiked ? likeText : removeLikeText,
            component: "span",
            className: isLiked ? 'active' : '',
            style: isLiked ? {
                color: _Theme__WEBPACK_IMPORTED_MODULE_12__/* .Color.green */ .Il.green
            } : {},
            disabled: !isLoggedIn,
            onClick: handleThumbUpClick,
            children: isLiked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_ThumbsUpOutlineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {})
        });
    }, [
        handleThumbUpClick,
        isLiked,
        isLoggedIn
    ]);
    var renderThumbDownButton = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            "aria-label": isDisliked ? dislikeText : removeDislikeText,
            component: "span",
            className: isDisliked ? 'active' : '',
            style: isDisliked ? {
                color: _Theme__WEBPACK_IMPORTED_MODULE_12__/* .Color.red */ .Il.red
            } : {},
            disabled: !isLoggedIn,
            onClick: handleThumbDownClick,
            children: isDisliked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_4___default()), {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_AlertDecagramOutlineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {})
        });
    }, [
        handleThumbDownClick,
        isDisliked,
        isLoggedIn
    ]);
    /**
   * Button that shows both liked and disliked state as follows:
   * - Neutral: Hollow like icon
   * - Liked: Green liked icon
   * - Disliked: Red dislike icon
   */ var renderComboButton = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            "aria-label": isDisliked ? removeDislikeText : isLiked ? removeLikeText : likeText,
            component: "span",
            className: [
                isLiked || isDisliked ? 'active' : '',
                isLiked ? 'liked' : '',
                isDisliked ? 'disliked' : ''
            ].join(' '),
            color: isLiked ? 'primary' : 'default',
            disabled: !isLoggedIn,
            onClick: isDisliked ? handleThumbDownClick : handleThumbUpClick,
            children: isDisliked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_4___default()), {}) : isLiked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((mdi_react_ThumbsUpOutlineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {})
        });
    }, [
        handleThumbUpClick,
        handleThumbDownClick,
        isLiked,
        isDisliked,
        isLoggedIn
    ]);
    return {
        isLiked: isLiked,
        isDisliked: isDisliked,
        isInCustomList: isInCustomList,
        listIDs: listIDs,
        handleThumbUpClick: handleThumbUpClick,
        handleThumbDownClick: handleThumbDownClick,
        handleToggleListClick: handleToggleListClick,
        renderThumbUpButton: renderThumbUpButton,
        renderThumbDownButton: renderThumbDownButton,
        renderComboButton: renderComboButton,
        dictionary: dictionary
    };
};
var useCompanyActionsInSearch = function(companyID) {
    var _ref = (0,_context_searchStore__WEBPACK_IMPORTED_MODULE_10__/* .useEditSearchItem */ .g6)(companyID), doEdit = _ref.doEdit, actionData = _objectWithoutProperties(_ref, [
        "doEdit"
    ]);
    return useCompanyActions(companyID, actionData, doEdit);
};
/**
 * Handle company actions in search results.
 * Updates the search result list and cache accordingly.
 */ 
var useCompanyActionsInPage = function(company) {
    var companyID = company.companyID, isLiked = company.isLiked, isDisliked = company.isDisliked, listIDs = company.listIDs;
    var companyIDString = "".concat(companyID);
    // Also edit search data to update (like, dislike, list) status when going back to search page / refreshing search etc.
    var ref = (0,_context_searchStore__WEBPACK_IMPORTED_MODULE_10__/* .useEditSearchItem */ .g6)(companyID, true), doSearchEdit = ref.doEdit;
    var _ref = useCompanyActionCacheState(function(_param) {
        var set = _param.set, state = _objectWithoutProperties(_param, [
            "set"
        ]);
        return {
            set: set,
            actionCache: state[companyIDString]
        };
    }, function(a, b) {
        return (0,zustand_shallow__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(a, b);
    }), set1 = _ref.set, actionCache = _ref.actionCache;
    // Cache of initial company state + new like, dislike & list changes
    var companyActionCache = actionCache || {
        companyID: companyID,
        isLiked: isLiked,
        isDisliked: isDisliked,
        listIDs: listIDs
    };
    // Update action data if company data changes
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        set1(_defineProperty({}, companyIDString, _objectSpread({}, companyActionCache, {
            isLiked: isLiked,
            isDisliked: isDisliked,
            listIDs: listIDs
        })));
    }, [
        companyID,
        isLiked,
        isDisliked,
        listIDs
    ]);
    var doEdit = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(data) {
        var currentState = useCompanyActionCacheState.getState()[companyIDString] || companyActionCache;
        set1(_defineProperty({}, companyIDString, _objectSpread({}, currentState, data)));
        doSearchEdit(data);
    }, [
        companyIDString
    ]);
    return useCompanyActions(companyID, companyActionCache, doEdit);
};
/**
 * Handle company actions in company page.
 * Updates the company data accordingly.
 */ 


/***/ }),

/***/ 14432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ VastuuGroupIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(868);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var _common_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72916);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  padding: 3px 4px;\n  font-size: 10px;\n  font-weight: normal;\n  line-height: 130%;\n  margin-left: 10px;\n  margin-right: -2px;\n  text-align: center;\n  color: #fff !important;\n  background-color: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var LetterIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4ceb0d07-0"
})(_templateObject(), function(props) {
    return props.bgColor;
});
var LetterIconComponent = function(_param) {
    var label = _param.label, tooltip = _param.tooltip, props = _objectWithoutProperties(_param, [
        "label",
        "tooltip"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        title: tooltip,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LetterIcon, _objectSpread({}, props, {
            children: label
        }))
    }));
};
var _obj;
var iconSettings = (_obj = {}, _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyFlag.IS_TAITOREKISTERI */ .Qi.IS_TAITOREKISTERI, {
    label: 'TR',
    bgColor: '#a78efd',
    tooltip: 'Yritys kuuluu Taitorekisteriin'
}), _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyFlag.IS_VALTTIKORTTI */ .Qi.IS_VALTTIKORTTI, {
    label: 'VK',
    bgColor: '#ef602d',
    tooltip: 'Yrityksell\xe4 on k\xe4yt\xf6ss\xe4 Valttikortti -palvelu'
}), _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyFlag.IS_LUOTETTAVAKUMPPANI */ .Qi.IS_LUOTETTAVAKUMPPANI, {
    label: 'LK',
    bgColor: '#0f9a60',
    tooltip: 'Yritykselt\xe4 on saatavissa Luotettava Kumppani -raportti'
}), _obj);
var VastuuGroupIcon = function(_param) /*#__PURE__*/ {
    var companyFlagID = _param.companyFlagID, rest = _objectWithoutProperties(_param, [
        "companyFlagID"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LetterIconComponent, _objectSpread({
        label: iconSettings[companyFlagID].label,
        bgColor: iconSettings[companyFlagID].bgColor,
        tooltip: iconSettings[companyFlagID].tooltip
    }, rest));
};



/***/ })

}]);